<template>
  <tr class="room-string" @keydown.enter="save" v-if="data">
    <td v-if="is_new && !group">
      <input type="text" v-model="data.key" placeholder="Keyname">
    </td>
    <td>
      <img v-if="data.media" :src="data.media" class="row_img">
      <input v-else type="file" @change="updatemedia" placeholder="Ljud" accept="image/*">
    </td>
    <td v-if="!group">
      <input type="text" v-model="data.group" placeholder="Grupp">
    </td>
    <td>
      <multiselect v-model="data.age_groups" :multiple="true" track-by="title" :options="age_groups" label="title" :searchable="false"></multiselect>

    </td>
    <td>
      <button class="button is-small is-default" @click="save"><i class="fa fa-save"></i></button>
      <button class="button is-small is-danger" v-if="group" @click="deleteString"><i class="fa fa-trash-o"></i>
      </button>
    </td>
  </tr>

</template>
<style type="text/css">
  .row_img { max-width: 200px;}
</style>
<script>
// const _ = require('lodash')
import RoomData from '@/mixins/RoomContent'
import Multiselect from 'vue-multiselect'

export default {
  name: 'RoomImage',
  mixins: [RoomData],
  data () {
    return {
      data: null,
      mediabutton: null,
      startdata: {
        content: null,
        media: null,
        group: null,
        age_groups: [],
        key: null,
        type: 'image'
      }
    }
  },
  props: ['orgdata', 'group', 'index', 'keyname', 'is_new'],
  components: { Multiselect },
  methods: {

  },
  mounted () {
    this.reset()
  }
}
</script>
